import { Amplify } from "aws-amplify";
import React from "react";
import ReactDOM from "react-dom/client";
import { createRoot } from "react-dom/client";
import { Application } from "./components/Application";
import { Providers } from "./components/Providers";
import "./i18n/config";
import "./index.css";
import { captureFederationErrorDescription } from "./federationErrorHandler";

// Static ESM imports — Vite bundles only the file referenced at build time,
// dead code elimination removes the unused branches in production builds.
import awsExportsDev from "./aws-exports-dev";
import awsExportsProd from "./aws-exports-prod";
import awsExportsTest from "./aws-exports-test";

const getAmplifyConfig = () => {
  const configFileName = import.meta.env.VITE_AMPLIFY_EXPORTS;
  switch (configFileName) {
    case "aws-exports-dev":
      return awsExportsDev;
    case "aws-exports-prod":
      return awsExportsProd;
    case "aws-exports-test":
      return awsExportsTest;
    default:
      throw new Error(`Invalid config file name: ${configFileName}`);
  }
};

captureFederationErrorDescription();

Amplify.configure(getAmplifyConfig());

if (import.meta.env.VITE_ENVIRONMENT !== "prod") {
  import("@axe-core/react").then((axe) => axe.default(React, ReactDOM, 3000));
}

if (import.meta.env.VITE_ENVIRONMENT === "prod") {
  console.log = () => {};
  console.error = () => {};
  console.debug = () => {};
}

const container = document.getElementById("root")!;
const root = createRoot(container);

// TODO: Change to this when we migrate to React 19
// const root = createRoot(container, {
//   // Callback called when an error is thrown and not caught by an ErrorBoundary.
//   onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
//     console.warn('Uncaught error', error, errorInfo.componentStack);
//   }),
//   // Callback called when React catches an error in an ErrorBoundary.
//   onCaughtError: Sentry.reactErrorHandler(),
//   // Callback called when React automatically recovers from errors.
//   onRecoverableError: Sentry.reactErrorHandler(),
// });

root.render(
  <Providers>
    <Application />
  </Providers>,
);
export { checkIfCorrect } from "./utils/Questions";
